import React from 'react';
import PropTypes from 'prop-types';
import { Surveys, ProgressSurveyQuestion } from 'utils/types';
import Survey from './Survey';
import NoSurveys from './NoSurveys';
import SurveyNotFound from './SurveyNotFound';
import { SFSurveysTenantLanguage } from "utils/types";

export default class SurveyView extends React.Component {

  get surveyId() {
    return this.props.surveyId || this.props.surveys[0].surveyId;
  }

  get noSurveys() {
    return this.props.surveys === null || this.props.surveys.length < 1;
  }

  get invalidSurveyId() {
    return !this.props.surveys.some(({surveyId}) => surveyId === this.surveyId);
  }

  render() {
    if ( !this.props.hasFetched ) return <div>Loading....</div>;
    if ( this.noSurveys ) return <NoSurveys progressSurveyWords={this.props.progressSurveyWords}/>;
    if ( this.invalidSurveyId ) return <SurveyNotFound progressSurveyWords={this.props.progressSurveyWords}/>;
    return (
      <Survey
        surveys={this.props.surveys}
        surveyId={this.surveyId}
        getStudentFolderLink={this.props.getStudentFolderLink}
        rebindStudentCards={this.props.rebindStudentCards}
        onFailure={this.props.onFailure}
        hasFetched={this.props.hasFetched}
        surveyQuestions={this.props.surveyQuestions}
        getSurveys={this.props.getSurveys}
        progressSurveyWords={this.props.progressSurveyWords}
      />
    )
  }
}

SurveyView.propTypes = {
  surveys: Surveys,
  surveyId: PropTypes.number,
  hasFetched: PropTypes.bool.isRequired,
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  onSurveySelect: PropTypes.func,
  getStudentFolderLink: PropTypes.func.isRequired,
  rebindStudentCards: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  getSurveys: PropTypes.func.isRequired,
  progressSurveyWords: SFSurveysTenantLanguage
};
